import { createContext } from "react";
import { FileManager } from "../core/manager";

export interface FileManagerStore {
	manager: FileManager;
}

export const FileManagerContext = createContext<FileManagerStore | null>(null);

const { Provider, Consumer } = FileManagerContext;

export { Provider, Consumer };
